export const ENROLLMENT_VERIFY_EMAIL = 'ENROLLMENT_VERIFY_EMAIL';

export const enrollmentVerifyEmail = () => dispatch =>
  dispatch({
    type: ENROLLMENT_VERIFY_EMAIL,
  });
